import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from './assets/header.png'; // Asegúrate de que la ruta a tu logo.svg sea correcta
import './Login.css'; // Tu archivo CSS original para estilos específicos
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode'; // Asegúrate de tener jwt-decode instalado
import { invite_user, start_sesion, start_sesion_email } from './utils/services'; // Asegúrate de que la ruta sea correcta y el servicio exista
import md5 from 'md5';
import packageJsonData from '../package.json'; // 1. Importa el objeto JSON completo

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { parametro } = location.state || {};
const appVersion = packageJsonData.version;

  // Estados para los campos de email y contraseña
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // Estado para mostrar mensajes de error o éxito al usuario
  const [message, setMessage] = useState({ type: '', text: '' });
  // Estado para indicar si se está cargando alguna operación (ej. login, reset)
  const [isLoading, setIsLoading] = useState(false);
  // Estado para controlar la visibilidad del modal de mensaje
  const [showModal, setShowModal] = useState(false);

  // Si hay token en la raíz "/", intentar ir a Dashboard (evita bucle: sin token no redirigimos)
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      navigate('/Dashboard', { replace: true });
    }
  }, [navigate]);

  // Función original para verificar la sesión y redirigir
  const checkSession = async (credential) => {
    
    try {
      const decoded = jwtDecode(credential);
      console.dir(decoded);

      const memberUpdate = await start_sesion(credential); // Llama a tu servicio de backend
      if (memberUpdate === "loggedin") {
        if (parametro !== undefined) {
          navigate(parametro);
        } else {
          navigate("/Dashboard");
        }
      } else {
        navigate("/");
        setMessage({ type: 'danger', text: 'There was an error. Try again.' });
      }
    } catch (error) {
      console.error("Error al verificar la sesión:", error);
      setMessage({ type: 'danger', text: 'Unexpected error' });
      navigate("/"); // Redirigir a la página de inicio en caso de error
    }
  };


  const checkSession_email = async ( email, passowrd) => {
    console.log("Verificando sesión con email:", email, passowrd);
    try {
      const memberUpdate = await start_sesion_email(email,passowrd); // Llama a tu servicio de backend
      console.log("RESULTADO DE START SESSION", memberUpdate);
      if (memberUpdate === "failed") {
        setMessage({ type: 'danger', text: 'Error logging in. Verify and try again.' });
        setIsLoading(false);
      
      } else {
        localStorage.setItem("token", memberUpdate);
        if (parametro !== undefined) {
          navigate(parametro);
        } else {
          navigate("/Dashboard");
        }
      }
    } catch (error) {
      console.error("Error al verificar la sesión:", error);
      setMessage({ type: 'danger', text: 'Unexpected Error.' });
      navigate("/"); // Redirigir a la página de inicio en caso de error
    }
  };

  // Manejador para el login con email y contraseña
  const handleEmailLogin = async () => {
    setMessage({ type: '', text: '' }); // Limpiar mensajes previos
    setIsLoading(true); // Indicar que una operación está en curso

    // Validar que ambos campos no estén vacíos
    if (!email || !password) {
      setMessage({ type: 'warning', text: 'Please type an email and password' });
      setIsLoading(false);
      return;
    }

    checkSession_email(email, md5(password));

    
  };


  
  // Manejador para la funcionalidad de "olvidé mi contraseña"
  const handleForgotPassword = async () => {
    setMessage({ type: '', text: '' }); // Limpiar mensajes previos
    setIsLoading(true); // Indicar que una operación está en curso

    // Validar que el campo de email no esté vacío
    if (!email) {
      setMessage({ type: 'warning', text: 'Plase, introduce an email to recover password.' });
      setIsLoading(false);
      return;
    }

    try {
      const usrList = await invite_user('',email);
      if (usrList === "INVALID"){
        setMessage({ type: 'danger', text: 'Email not valid' });
      }else{
        setMessage({ type: 'success', text: 'Recovery email sent, follow the instructions.' });
      }
    } catch (error) {
      // Capturar errores de red o del fetch
      console.error('Password recovery failed:', error);
      setMessage({ type: 'danger', text: 'There was an error resetting your password.' });
    } finally {
      setIsLoading(false); // Finalizar la operación de carga
    }
  };

  // Manejador de éxito para el login de Google
  const handleGoogleSuccess = async (credentialResponse) => {
    console.log('Credencial de Google:', credentialResponse?.credential);
    localStorage.setItem("token", credentialResponse?.credential);
    await checkSession(credentialResponse?.credential);
    setMessage({ type: 'success', text: '¡Login con Google exitoso!' });
  };

  // Manejador de error para el login de Google
  const handleGoogleError = () => {
    console.log("Login de Google fallido");
    setMessage({ type: 'danger', text: "No se pudo iniciar sesión con Google. Inténtalo de nuevo." });
  };


  return (
    // Incluye el CDN de Bootstrap para que los estilos funcionen
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
        rel="stylesheet"
        xintegrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
        crossOrigin="anonymous"
      />
      <script
        src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"
        xintegrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz"
        crossOrigin="anonymous"
      ></script>

      <div className="App d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <header className="card p-4 shadow-lg text-center" style={{ maxWidth: '400px', width: '100%' }}>
          <img src={logo} className="App-logo mb-4 mx-auto d-block" alt="logo" style={{ width: '120px', height: '120px' }} />
          <h1 className="h3 mb-3 fw-normal">TOMi Management System</h1>

          {/* Sección de Login con Email y Contraseña */}
          <div className="mb-4">
            <h2 className="h5 mb-3">Login using email</h2>
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="emailInput"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isLoading}
              />
              <label htmlFor="emailInput">Email</label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="passwordInput"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
              <label htmlFor="passwordInput">Password</label>
            </div>
            <button
              onClick={handleEmailLogin}
              disabled={isLoading}
              className="w-100 btn btn-lg btn-primary mb-3"
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {' '}Loading...
                </>
              ) : (
                'Login'
              )}
            </button>
            <div className="text-end">
              <a
                href="#"
                onClick={handleForgotPassword}
                className="text-decoration-none text-primary"
                aria-label="Forgot the password"
              >
               Forgot the password?
              </a>
            </div>
          </div>

          {/* Separador */}
          <div className="d-flex align-items-center my-4">
            <hr className="flex-grow-1" />
            <span className="mx-2 text-muted">o</span>
            <hr className="flex-grow-1" />
          </div>

          {/* Sección de Login con Google */}
          <div className="mb-3 d-flex justify-content-center">
            <GoogleLogin
              accesstype="offline"
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              // Puedes personalizar el botón de Google aquí si lo deseas
              // theme="filled_blue"
              // size="large"
              // text="signin_with"
            />
          </div>

          {/* Mensajes de error o éxito */}
          {message.text && (
            <div className={`alert alert-${message.type} mt-4`} role="alert">
              {message.text}
            </div>
          )}
        </header>

        {/* Modal para mensajes (reemplazo de alert()) */}
        {showModal && (
          <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Información</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <p>{message.text}</p>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>Cerrar</button>
                </div>
              </div>
            </div>
          </div>
          
        )}
        <div>{appVersion && `v${appVersion}`}</div>
      </div>
    </>
  );
}

export default Login;
